import { render, staticRenderFns } from "./AddNotification.vue?vue&type=template&id=4960704e&"
import script from "../../../public/js/img/Discoveryjs/Notif/AddNotif.js?vue&type=script&lang=js&"
export * from "../../../public/js/img/Discoveryjs/Notif/AddNotif.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports